import React from 'react';
import dayjs from 'dayjs';
import picsioConfig from '../../../../../../config';

const getStyles = (index) => ({
  fontSize: index !== 0 ? '0.8em' : '1em',
  opacity: index !== 0 ? 0.8 : 1,
  marginTop: index !== 0 ? 5 : 0,
});

const makeTooltipText = (text, colorAt, colorBy) => {
  if (!picsioConfig.isMainApp) return text;

  const result = [text];
  if (colorAt) {
    result.push(`Updated at: ${dayjs(colorAt).format('lll')}`);
  }
  if (colorBy?._id) {
    if (result[1]) {
      result[1] += ` by ${colorBy.displayName || colorBy.email || colorBy._id}`;
    } else {
      result.push(`Updated by ${colorBy.displayName || colorBy.email || colorBy._id}`);
    }
  }

  return () => <>{result.map((t, i) => <div key={t + i} style={getStyles(i)}>{t}</div>)}</>;
};

export default makeTooltipText;
